import React from "react";
import Label from "./Label";
import { inputClassName, inputErrorClassName } from "./classNames";
import ErrorIcon from "../Icons/ErrorIcon";

const PasswordInput = ({
  id,
  label,
  placeholder = "Enter your text",
  register,
  errors,
}) => {
  return (
    <div>
      <Label htmlFor={id} label={label} />
      <input
        id={id}
        type="password"
        autoComplete={id}
        placeholder={placeholder}
        className={inputClassName}
        {...register}
      />
      {/* {errors && errors[id] && (
        <p className={inputErrorClassName}>{errors[id].message}</p>
      )} */}
      {errors && errors[id] && (
        <div className="text-red-500 text-sm mt-1 flex items-center">
          <ErrorIcon />
          <span>{errors[id].message}</span>
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
